import React from "react";
import "../style/PosHeader.css";

const PosHeader = () => {
  return (
    <div className="PosHeader">
      <h6>
        Изработено од студентите на академијата за програмирање на
        <a
          href="https://brainster.co/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Brainster
        </a>
      </h6>
    </div>
  );
};

export default PosHeader;
